import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import CheckboxField from '@/shared/components/form/CheckBox';
import { Row, Col, ButtonToolbar, Button, FormGroup } from 'reactstrap';
import formValidation from "@/shared/validation/merchants/addMerchant";
import renderSelectField from '@/shared/components/form/Select';
import axios from 'axios';
import {mapFormDataUploads} from '@/shared/helpers'
import renderDropZoneField from '@/shared/components/form/DropZone';
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import {TOA_OPTIONS} from '@/shared/options'
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'
import getCountries from "@/service/getCountries";
import getRewardPlatform from "@/service/getRewardPlatform";
import getCategories from "@/service/getCategories";
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
const AddMerchantForm = ({ organization }) => {

    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [useVirtualInventory, setUseVirtualInventory] = useState(false)
    const [useCronjob, setUsecronjob] = useState(false)
    const [toaOptions, setToaOptions] = useState(false)
    const [errors, setErrors] = useState(null)
    const [countries, setCountries] = React.useState([])
    const [rewardPlatforms, setRewardPlatforms] = React.useState([])
    const [rewardPlatform, setRewardPlatform] = React.useState(0)
    const [categories, setCategories] = React.useState([])

    const onChangeUseVirtualInventory = () => {
        setUseVirtualInventory( !useVirtualInventory )
    }


    const onChangeUseCronjob = () => {
      setUsecronjob( !useCronjob )
    }

    const loadTangoApiConfigurations = async (reward_platform_id) => {
        try {
          const response = await axios.get(`/tango-api/index?reward_platform_id=${reward_platform_id}`);
          if (response.data.length === 0) return [];
          let options = [];
          response.data.map(row => {
            options.push({
              value: row.id,
              label: row.name
            });
          });
          return options;
        } catch (e) {
          throw new Error(`API error:${e?.message}`);
        }
      }

    useEffect( ()=>{
        setLoading(true)
        let reward_platform_id = null;
        if(rewardPlatform) {
          reward_platform_id = rewardPlatform;
        }
        loadTangoApiConfigurations(reward_platform_id).then( res => {
            setToaOptions(res);
            setLoading(false)
        })
    }, [rewardPlatform]);

    const onChangePlatform = (value) => {
      let val = value?.value;
      setRewardPlatform(val)
    }

    const onSubmit = values => {
        // alert(JSON.stringify(values))

        console.log(values);

        values.use_virtual_inventory       = values.use_virtual_inventory ? 1 : 0;
        values.set_second_email_from_tango = values.set_second_email_from_tango ? 1 : 0;
        values.use_tango_api               = values.use_tango_api ? 1 : 0;
        values.use_cronjob = values.use_cronjob ? 1 : 0;
        values.physical_card_option = values.physical_card_option ? 1 : 0;
        // `category` is a plain name string when untouched (never set by the user) or an
        // `{value,label}` react-select option once touched; null when explicitly cleared.
        values.category = typeof values.category === 'object' ? (values.category?.value ?? '') : (values.category ?? '');

        console.log(values);

        const data = mapFormDataUploads( values )
        if (values.physical_card_option && values.shipping_fees && Array.isArray(values.shipping_fees)) {
            // Remove the broken native serialization string if it was appended
            data.delete('shipping_fees');

            // Map each row property to a specific index token key
            values.shipping_fees.forEach((fee, index) => {
                data.append(`shipping_fees[${index}][min_qty]`, fee.min_qty ?? '');
                data.append(`shipping_fees[${index}][max_qty]`, fee.max_qty ?? '');
                data.append(`shipping_fees[${index}][fee]`, fee.fee ?? '');
            });
        } else {
            data.delete('shipping_fees');
        }
        setLoading(true)
        axios.post(`/merchant`, data, {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        })
        .then( (res) => { 
        console.log(res)
          if(res.status == 200)  {
            window.location = `/merchants?message=Merchant added successfully!`
          }
        })
        .catch( error => {
            console.log(error)
            // console.log(JSON.stringify(error.response.data.errors));
            setErrors(error.response.data.errors);
            dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
            // throw new Error(`API error:${e?.message}`);
            setLoading(false)
        })
    }

  useEffect(() => {
    if (countries.length === 0) {
      getCountries()
        .then(result => {
          setCountries(labelizeNamedData(result))
        })
    }
  },)

  useEffect(() => {
    if (rewardPlatforms.length === 0) {
      getRewardPlatform()
        .then(result => {
          setRewardPlatforms(labelizeNamedData(result))
        })
    }
  },)

  useEffect(() => {
    if (categories.length === 0 && organization?.id) {
      getCategories(organization.id)
        .then(result => {
          setCategories(labelizeNamedData(result, ['name', 'name']))
        })
    }
  }, [organization?.id])

    const onClickCancel = () => {
        window.location = `/merchants`
    }

    if( loading ) return <p>Loading...</p>

    return (
    <Form
        onSubmit={onSubmit}
        mutators={{ ...arrayMutators }} // Required mutators initialization for handling FieldArrays
        validate={(values) => formValidation.validateForm(values)}
        initialValues={{
          reward_platform_id:rewardPlatform,
          shipping_fees: [
            { min_qty: 1, max_qty: 30, fee: 25.00 },
            { min_qty: 31, max_qty: 100, fee: 40.00 },
            { min_qty: 101, max_qty: 250, fee: 60.00 },
            { min_qty: 251, max_qty: 500, fee: 80.00 }
          ]
        }}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => (
    <form className="form" onSubmit={handleSubmit}>
        {errors && 
            <div className="alert alert-danger fade show w100 mb-4" role="alert">
                <div className="alert__content">{errors}</div>
            </div>
        }
        <Row className='w100'>
            <Col md="6" lg="6" xl="6">
                <h3 className="mb-4">Add Merchant</h3>
            </Col>
            <Col md="6" lg="6" xl="6" className='text-right'>
                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                    <Button outline color="primary" className="mr-3" onClick={onClickCancel}>Cancel</Button>{' '}
                    <Button type="submit" disabled={loading || pristine} className="btn btn-primary" color="#ffffff">Save</Button>
                </ButtonToolbar>
            </Col>
        </Row>
        <Row>
            <Col md="4" lg="4" xl="4">
                <Field name="name">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Merchant Name</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Merchant Name" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>
            </Col>
            <Col md="4" lg="4" xl="4">
                <Field name="merchant_code">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Merchant Code</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Merchant Code" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>
            </Col>
            <Col md="4" lg="4" xl="4">

                <div className="form__form-group">
                    <CheckboxField 
                        name="is_pfi_merchant"
                        label="PFI Merchant"
                    />
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <CheckboxField 
                        name="is_default"
                        label="Default"
                    />
                </div>
                <div className="form__form-group">
                    <CheckboxField 
                        name="is_premium"
                        label="Premium"
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <CheckboxField 
                    name="physical_order"
                    label="Physical Order"
                />
                </div>
                <div className="form__form-group">
                    <CheckboxField 
                        name="requires_shipping"
                        label="Requires Shipping"
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <CheckboxField 
                        name="giftcodes_require_pin"
                        label="Gift Codes Require PIN"
                    />
                </div>
                <div className="form__form-group">
                    <CheckboxField 
                    name="display_popup"
                    label="Display Popup"
                />
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <CheckboxField 
                        name="get_gift_codes_from_root"
                        label="Get Gift Codes from root"
                    /> 
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
            <div className="form__form-group">
                  <CheckboxField 
                    name="is_recommended"
                    label="Recommended"
                  />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field name="physical_card_option" type="checkbox">
                        {({ input }) => (
                            <CheckboxField 
                                {...input}
                                label="Physical Card option" 
                            />
                        )}
                    </Field>
                </div>
            </Col>
        </Row>
        {/* DYNAMIC VISA OPTIONS REPEATER BLOCK */}
        {values.physical_card_option && (
            <div className="p-3 mb-4 rounded border" style={{ backgroundColor: 'rgb(254 254 254)' }}>
                <h4 className="mb-3 thick size16" style={{ color: '#4B5563' }}>Physical Visa Card Configuration Metrics</h4>
                <Row>
                    <Col md="4">
                        <Field name="fulfillment_fee_per_card">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Fulfillment Fee Per Card ($)</span>
                                    <div className="form__form-group-field">
                                        <input type="number" step="0.01" {...input} placeholder="0.50" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            )}
                        </Field>
                    </Col>
                    <Col md="4">
                        <Field name="visa_premium_fee">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Visa Premium fee(%)</span>
                                    <div className="form__form-group-field">
                                        <input type="number" min="0" max="100" step="0.01" {...input} placeholder="4" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>

                <h5 className="mt-3 mb-2 size14 font-weight-bold">Custom Shipping Tiers</h5>
               <FieldArray name="shipping_fees">
                    {({ fields }) => (
                        <div>
                            {fields.map((name, index) => (
                                <Row key={name} className="align-items-center mb-2 mt-0">
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Min Qty</span>
                                            <Field name={`${name}.min_qty`}>
                                                {({ input }) => <input type="number" className="form-control" placeholder="0" {...input} />}
                                            </Field>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Max Qty</span>
                                            <Field name={`${name}.max_qty`}>
                                                {({ input }) => <input type="number" className="form-control" placeholder="30" {...input} />}
                                            </Field>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Fee Amount</span>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text small" 
                                                        style={{ 
                                                            fontSize: '12px',
                                                            backgroundColor: '#f6f6f6',
                                                            borderColor: '#f0f1f3'
                                                         }}>
                                                        $
                                                    </span>
                                                </div>
                                                <Field name={`${name}.fee`}>
                                                    {({ input }) => (
                                                        <input 
                                                            type="number" 
                                                            step="0.01" 
                                                            className="form-control" 
                                                            placeholder="0.00" 
                                                            {...input} 
                                                        />
                                                    )}
                                                </Field>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3" >
                                        <Button type="button" color="danger" className='m-0' outline size="sm" onClick={() => fields.remove(index)}>
                                            Remove
                                        </Button>
                                    </Col>
                                </Row>
                            ))}
                            <Button type="button" color="success" size="sm" className="mt-2" onClick={() => fields.push({ min_qty: '', max_qty: '', fee: '' })}>
                                + Add New
                            </Button>
                        </div>
                    )}
                </FieldArray>
            </div>
        )}
      <Row>
        <Col md="6" lg="4" xl="4">
          <Field name="countries">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Country</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <Field
                      name="country_id"
                      component={renderSelectField}
                      options={countries}
                    />
                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <Field name="reward_platform_id">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Reward Platform</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <Field
                      name="reward_platform_id"
                      component={renderSelectField}
                      options={rewardPlatforms}
                      parse={value => {
                        onChangePlatform(value)
                        return value;
                      }}
                    />
                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col md="6" lg="4" xl="4">
          <div className="form__form-group">
            <span className="form__form-group-label">Category</span>
            <div className="form__form-group-field">
              <div className="form__form-group-row">
                <Field
                  name="category"
                  component={renderSelectField}
                  options={categories}
                  isClearable
                  placeholder="Select category"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="6" lg="6" xl="6">
          <div>
            <div className="form__form-group">
              <span className="form__form-group-label">Reward Platform Configurations</span>
              <div className="form__form-group-field">
                <Field
                  name="toa_id"
                  component={renderSelectField}
                  options={toaOptions}
                />
              </div>
            </div>
            <div className="form__form-group">
              <Field
                name="set_second_email_from_tango"
                type="checkbox"
                component={CheckboxField}
                label="Send the second email from Reward Platform"
              />
            </div>
          </div>
        </Col>
      </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                 <div className="form__form-group">
                        <Field
                            name="use_virtual_inventory"
                            label="Use Virtual Inventory"
                            type="checkbox"
                            component={CheckboxField}
                            parse={ value => {
                                onChangeUseVirtualInventory()
                                return value
                            }}
                        />
                    </div>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                {useVirtualInventory ? (
                    <Row>
                        <Col md="6" lg="6" xl="6">
                            <Field name="virtual_denominations">
                                {({input, meta}) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Virtual Denominations</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <input  type="text" {...input} placeholder=""/>
                                                {meta.touched && meta.error &&
                                                <span className="form__form-group-error">{meta.error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                        <Col md="6" lg="6" xl="6">
                            <Field name="virtual_discount">
                                {({input, meta}) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Virtual Discount</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <input  type="text" {...input} placeholder=""/>
                                                {meta.touched && meta.error &&
                                                <span className="form__form-group-error">{meta.error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>
                ) : '' }
            </Col>
        </Row>
        <Row>
          <Col md="6" lg="6" xl="6">
            <div className="form__form-group">
              <Field
                name="use_cronjob"
                label="Use Cronjob to generate Test Codes"
                type="checkbox"
                component={CheckboxField}
                parse={ value => {
                  onChangeUseCronjob()
                  return value
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="6" lg="6" xl="6">
            {useCronjob ? (
              <Row>
                <Col md="6" lg="6" xl="6">
                  <Field name="test_denominations">
                    {({input, meta}) => (
                      <div className="form__form-group">
                        <span className="form__form-group-label">Test Denominations</span>
                        <div className="form__form-group-field">
                          <div className="form__form-group-row">
                            <input  type="text" {...input} placeholder=""/>
                            {meta.touched && meta.error &&
                              <span className="form__form-group-error">{meta.error}</span>}
                          </div>
                        </div>
                      </div>
                    )}
                  </Field>
                </Col>
                <Col md="6" lg="6" xl="6">
                  <Field name="test_discount">
                    {({input, meta}) => (
                      <div className="form__form-group">
                        <span className="form__form-group-label">Test Discount</span>
                        <div className="form__form-group-field">
                          <div className="form__form-group-row">
                            <input  type="text" {...input} placeholder=""/>
                            {meta.touched && meta.error &&
                              <span className="form__form-group-error">{meta.error}</span>}
                          </div>
                        </div>
                      </div>
                    )}
                  </Field>
                </Col>
              </Row>
            ) : '' }
          </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                <Field name="website">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Website</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Website" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>  
            </Col>
        </Row>        
        <Row className='mb-3'>
            <Col md="8" lg="8" xl="8">
                <Field
                    name="description"
                    component={WYSIWYGEditor}
                />
            </Col>
        </Row>
        <Row className='mb-3'>
            <Col md="8" lg="8" xl="8">
                <Field
                    name="redemption_instruction"
                    component={WYSIWYGEditor}
                />
            </Col>
        </Row>
        <Row>
            <Col md="8" lg="8" xl="8">
                <div className="form__form-group">
                    <span className="form__form-group-label">Logo</span>
                    <div className="form__form-group-field">
                        <Field
                        name="logo"
                        component={renderDropZoneField}
                        customHeight
                        multiple={false}
                        />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Icon</span>
                    <div className="form__form-group-field">
                        <Field
                        name="icon"
                        component={renderDropZoneField}
                        customHeight
                        />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Large Icon</span>
                    <div className="form__form-group-field">
                        <Field
                        name="large_icon"
                        component={renderDropZoneField}
                        customHeight
                        />
                    </div>
                </div>
            </Col>
        </Row>
    </form>
    )}
  </Form>
)}

export default connect(state => ({
    organization: state.organization
}))(AddMerchantForm);
